export default __webpack_public_path__ + "static/media/13-2.d2703d85.jpg";